export default {"src":"/_next/static/media/invoice-paying.ef39f2ca.gif","height":500,"width":500,"blurWidth":0,"blurHeight":0};